// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CareerOutlookFact,
    CareerOutlookFactFromJSON,
    CareerOutlookFactToJSON,
    CareerOverviewCard,
    CareerOverviewCardFromJSON,
    CareerOverviewCardToJSON,
} from './';

/**
 * 
 * @export
 * @interface CareerOutlook
 */
export interface CareerOutlook {
    /**
     * 
     * @type {CareerOverviewCard}
     * @memberof CareerOutlook
     */
    demand?: CareerOverviewCard;
    /**
     * Get related facts.
     * @type {Array<CareerOutlookFact>}
     * @memberof CareerOutlook
     */
    readonly facts?: Array<CareerOutlookFact>;
    /**
     * 
     * @type {number}
     * @memberof CareerOutlook
     */
    jobOpenings?: number;
}

export function CareerOutlookFromJSON(json: any): CareerOutlook {
    return {
        'demand': !exists(json, 'demand') ? undefined : CareerOverviewCardFromJSON(json['demand']),
        'facts': !exists(json, 'facts') ? undefined : (json['facts'] as Array<any>).map(CareerOutlookFactFromJSON),
        'jobOpenings': !exists(json, 'job_openings') ? undefined : json['job_openings'],
    };
}

export function CareerOutlookToJSON(value?: CareerOutlook): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'demand': CareerOverviewCardToJSON(value.demand),
        'job_openings': value.jobOpenings,
    };
}


